import React, { useEffect, useState } from 'react';
import API from '../api';
import { useTranslation } from 'react-i18next';

function DriverForm({ driver, onSubmit }) {
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [error, setError] = useState('');
  // قائمة الألوان الرسمية
  const colorOptions = [
    'white', 'black', 'red', 'blue', 'green', 'yellow', 'gray', 'silver', 'brown', 'orange', 'beige', 'gold', 'purple', 'pink'
  ];
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [vehicleType, setVehicleType] = useState('');
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [color, setColor] = useState('');
  const [manufactureYear, setManufactureYear] = useState('');
  const [isAvailable, setIsAvailable] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [notes, setNotes] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (driver) {
      setName(driver.name);
      setPhone(driver.phone);
      setEmail(driver.email || '');
      setLicenseNumber(driver.license_number || '');
      setVehicleType(driver.vehicle_type || '');
      setVehicleNumber(driver.vehicle_number || '');
  setColor(driver.color || '');
      setManufactureYear(driver.manufacture_year || '');
      setManufacturer(driver.manufacturer || '');
      setModel(driver.model || '');
      setIsAvailable(driver.is_available);
      setIsActive(driver.is_active);
      setNotes(driver.notes || '');
    } else {
      setName('');
      setPhone('');
      setEmail('');
      setLicenseNumber('');
      setVehicleType('');
      setVehicleNumber('');
  setColor('');
      setManufactureYear('');
      setManufacturer('');
      setModel('');
      setIsAvailable(true);
      setIsActive(true);
      setNotes('');
    }
  }, [driver]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const data = { 
      name, phone, email, license_number: licenseNumber, 
      vehicle_type: vehicleType, vehicle_number: vehicleNumber,
      color,
      manufacture_year: manufactureYear ? parseInt(manufactureYear) : null,
      manufacturer, model,
      is_available: isAvailable, is_active: isActive, notes 
    };
    if (driver) {
      API.put(`drivers/${driver.id}/`, data)
        .then(onSubmit)
        .catch(err => {
          setError(err.response?.data?.detail || err.response?.data || 'Unknown error');
        });
    } else {
      API.post('drivers/', data)
        .then(onSubmit)
        .catch(err => {
          setError(err.response?.data?.detail || err.response?.data || 'Unknown error');
        });
    }
    setName(''); setPhone(''); setEmail(''); setLicenseNumber('');
    setVehicleType(''); setVehicleNumber(''); setIsAvailable(true); 
    setIsActive(true); setNotes('');
  };

  return (
    <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px'}}>
      {error && <div style={{color: 'red', marginBottom: '10px'}}>{typeof error === 'string' ? error : JSON.stringify(error)}</div>}
      <input className="form-input" placeholder={t('Name')} value={name} onChange={e => setName(e.target.value)} required />
      <input className="form-input" placeholder={t('Phone')} value={phone} onChange={e => setPhone(e.target.value)} required />
      <input className="form-input" placeholder={t('Email')} type="email" value={email} onChange={e => setEmail(e.target.value)} />
      <input className="form-input" placeholder={t('License Number')} value={licenseNumber} onChange={e => setLicenseNumber(e.target.value)} />
      <select className="form-input" value={vehicleType} onChange={e => setVehicleType(e.target.value)} required>
        <option value="">{t('Select Vehicle Type')}</option>
        <option value="car">{t('Car')}</option>
        <option value="motorcycle">{t('Motorcycle')}</option>
        <option value="van">{t('Van')}</option>
        <option value="truck">{t('Truck')}</option>
        <option value="bus">{t('Bus')}</option>
        <option value="suv">{t('SUV')}</option>
        <option value="minivan">{t('Minivan')}</option>
        <option value="bicycle">{t('Bicycle')}</option>
      </select>
  <input className="form-input" placeholder={t('Vehicle Number')} value={vehicleNumber} onChange={e => setVehicleNumber(e.target.value)} />
  <input className="form-input" placeholder={t('Manufacturer')} value={manufacturer} onChange={e => setManufacturer(e.target.value)} />
  <input className="form-input" placeholder={t('Model')} value={model} onChange={e => setModel(e.target.value)} />
      <select className="form-input" value={color} onChange={e => setColor(e.target.value)}>
        <option value="">{t('Select Color')}</option>
        {colorOptions.map(opt => (
          <option key={opt} value={opt}>{t(opt.charAt(0).toUpperCase() + opt.slice(1))}</option>
        ))}
      </select>
      <input className="form-input" placeholder={t('Manufacture Year')} type="number" min="1900" max="2100" value={manufactureYear} onChange={e => setManufactureYear(e.target.value)} />
      <div style={{display: 'flex', gap: '20px'}}>
        <label>
          <input type="checkbox" checked={isAvailable} onChange={e => setIsAvailable(e.target.checked)} />
          {t('Available')}
        </label>
        <label>
          <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} />
          {t('Active')}
        </label>
      </div>
      <textarea className="form-input" placeholder={t('Notes')} value={notes} onChange={e => setNotes(e.target.value)} />
      <button type="submit">{driver ? t('Update Driver') : t('Add Driver')}</button>
    </form>
  );
}

export default DriverForm;
